"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMMacroOpOptimizer = void 0;
const inversify_1 = require("inversify");
const VMOpCode_1 = require("../../../enums/vm-transformers/VMOpCode");
let VMMacroOpOptimizer = class VMMacroOpOptimizer {
    constructor() {
        this.usedMacroOps = new Set();
        this.patterns = [
            {
                opcodes: [VMOpCode_1.VMOpCode.LOAD_LOCAL, VMOpCode_1.VMOpCode.PUSH_CONST, VMOpCode_1.VMOpCode.ADD, VMOpCode_1.VMOpCode.STORE_LOCAL],
                validate: (instrs, i, constants) => {
                    const loadLocal = instrs[i];
                    const pushConst = instrs[i + 1];
                    const storeLocal = instrs[i + 3];
                    return (loadLocal.arg === storeLocal.arg &&
                        pushConst.arg !== undefined &&
                        constants[pushConst.arg] === 1);
                },
                macroOp: VMOpCode_1.VMOpCode.MACRO_INC_LOCAL,
                extractArgs: (instrs, i) => ({
                    arg: instrs[i].arg
                })
            },
            {
                opcodes: [VMOpCode_1.VMOpCode.LOAD_LOCAL, VMOpCode_1.VMOpCode.PUSH_CONST, VMOpCode_1.VMOpCode.SUB, VMOpCode_1.VMOpCode.STORE_LOCAL],
                validate: (instrs, i, constants) => {
                    const loadLocal = instrs[i];
                    const pushConst = instrs[i + 1];
                    const storeLocal = instrs[i + 3];
                    return (loadLocal.arg === storeLocal.arg &&
                        pushConst.arg !== undefined &&
                        constants[pushConst.arg] === 1);
                },
                macroOp: VMOpCode_1.VMOpCode.MACRO_DEC_LOCAL,
                extractArgs: (instrs, i) => ({
                    arg: instrs[i].arg
                })
            },
            {
                opcodes: [VMOpCode_1.VMOpCode.LOAD_LOCAL, VMOpCode_1.VMOpCode.PUSH_CONST, VMOpCode_1.VMOpCode.ADD],
                macroOp: VMOpCode_1.VMOpCode.MACRO_ADD_LOCAL_CONST,
                extractArgs: (instrs, i) => ({
                    arg: instrs[i].arg,
                    arg2: instrs[i + 1].arg
                })
            },
            {
                opcodes: [VMOpCode_1.VMOpCode.LOAD_LOCAL, VMOpCode_1.VMOpCode.PUSH_CONST, VMOpCode_1.VMOpCode.SUB],
                macroOp: VMOpCode_1.VMOpCode.MACRO_SUB_LOCAL_CONST,
                extractArgs: (instrs, i) => ({
                    arg: instrs[i].arg,
                    arg2: instrs[i + 1].arg
                })
            },
            {
                opcodes: [VMOpCode_1.VMOpCode.LOAD_LOCAL, VMOpCode_1.VMOpCode.PUSH_CONST, VMOpCode_1.VMOpCode.MUL],
                macroOp: VMOpCode_1.VMOpCode.MACRO_MUL_LOCAL_CONST,
                extractArgs: (instrs, i) => ({
                    arg: instrs[i].arg,
                    arg2: instrs[i + 1].arg
                })
            },
            {
                opcodes: [VMOpCode_1.VMOpCode.LOAD_LOCAL, VMOpCode_1.VMOpCode.PUSH_CONST, VMOpCode_1.VMOpCode.LT],
                macroOp: VMOpCode_1.VMOpCode.MACRO_LT_LOCAL_CONST,
                extractArgs: (instrs, i) => ({
                    arg: instrs[i].arg,
                    arg2: instrs[i + 1].arg
                })
            },
            {
                opcodes: [VMOpCode_1.VMOpCode.LOAD_LOCAL, VMOpCode_1.VMOpCode.GET_PROP],
                macroOp: VMOpCode_1.VMOpCode.MACRO_LOAD_LOCAL_GET_PROP,
                extractArgs: (instrs, i) => ({
                    arg: instrs[i].arg,
                    arg2: instrs[i + 1].arg
                })
            }
        ];
    }
    getUsedMacroOps() {
        return this.usedMacroOps;
    }
    resetUsedMacroOps() {
        this.usedMacroOps.clear();
    }
    optimize(bytecode) {
        this.usedMacroOps.clear();
        const instructions = bytecode.instructions;
        const constants = bytecode.constants;
        const optimizedInstructions = [];
        const indexMap = new Map();
        let i = 0;
        while (i < instructions.length) {
            indexMap.set(i, optimizedInstructions.length);
            const matchResult = this.tryMatchPattern(instructions, i, constants);
            if (matchResult) {
                const macroInstr = {
                    op: matchResult.macroOp,
                    ...matchResult.args
                };
                optimizedInstructions.push(macroInstr);
                this.usedMacroOps.add(matchResult.macroOp);
                for (let j = 1; j < matchResult.consumedCount; j++) {
                    indexMap.set(i + j, optimizedInstructions.length - 1);
                }
                i += matchResult.consumedCount;
            }
            else {
                optimizedInstructions.push(instructions[i]);
                i++;
            }
        }
        this.fixJumpTargets(optimizedInstructions, indexMap, instructions.length);
        bytecode.instructions = optimizedInstructions;
        return bytecode;
    }
    tryMatchPattern(instructions, startIndex, constants) {
        for (const pattern of this.patterns) {
            if (this.matchesPattern(instructions, startIndex, pattern, constants)) {
                return {
                    macroOp: pattern.macroOp,
                    args: pattern.extractArgs(instructions, startIndex),
                    consumedCount: pattern.opcodes.length
                };
            }
        }
        return null;
    }
    matchesPattern(instructions, startIndex, pattern, constants) {
        if (startIndex + pattern.opcodes.length > instructions.length) {
            return false;
        }
        for (let i = 0; i < pattern.opcodes.length; i++) {
            const instr = instructions[startIndex + i];
            if (instr.op !== pattern.opcodes[i]) {
                return false;
            }
        }
        for (let i = 1; i < pattern.opcodes.length; i++) {
            if (this.isJumpTarget(instructions, startIndex + i)) {
                return false;
            }
        }
        if (pattern.validate && !pattern.validate(instructions, startIndex, constants)) {
            return false;
        }
        return true;
    }
    isJumpTarget(instructions, targetIndex) {
        for (const instr of instructions) {
            if (this.isInstructionJumpingTo(instr, targetIndex)) {
                return true;
            }
        }
        return false;
    }
    isInstructionJumpingTo(instr, targetIndex) {
        if ('target' in instr && instr.target === targetIndex) {
            return true;
        }
        if (instr.op === VMOpCode_1.VMOpCode.TRY_START) {
            const tryInstr = instr;
            if (tryInstr.catchIndex === targetIndex ||
                tryInstr.finallyIndex === targetIndex ||
                tryInstr.endIndex === targetIndex) {
                return true;
            }
        }
        return false;
    }
    fixJumpTargets(instructions, indexMap, originalLength) {
        indexMap.set(originalLength, instructions.length);
        for (const instr of instructions) {
            this.fixInstructionJumpTarget(instr, indexMap);
            this.fixTryStartIndices(instr, indexMap);
        }
    }
    fixInstructionJumpTarget(instr, indexMap) {
        if ('target' in instr) {
            const newTarget = indexMap.get(instr.target);
            if (newTarget !== undefined) {
                instr.target = newTarget;
            }
        }
    }
    fixTryStartIndices(instr, indexMap) {
        if (instr.op !== VMOpCode_1.VMOpCode.TRY_START) {
            return;
        }
        const tryInstr = instr;
        if (tryInstr.catchIndex !== undefined) {
            const newCatch = indexMap.get(tryInstr.catchIndex);
            if (newCatch !== undefined) {
                tryInstr.catchIndex = newCatch;
            }
        }
        if (tryInstr.finallyIndex !== undefined) {
            const newFinally = indexMap.get(tryInstr.finallyIndex);
            if (newFinally !== undefined) {
                tryInstr.finallyIndex = newFinally;
            }
        }
        if (tryInstr.endIndex !== undefined) {
            const newEnd = indexMap.get(tryInstr.endIndex);
            if (newEnd !== undefined) {
                tryInstr.endIndex = newEnd;
            }
        }
    }
};
exports.VMMacroOpOptimizer = VMMacroOpOptimizer;
exports.VMMacroOpOptimizer = VMMacroOpOptimizer = __decorate([
    (0, inversify_1.injectable)()
], VMMacroOpOptimizer);
